
export const modules = {
  Dashboard:"DashBoard",
  Orders: "Orders",
  Inventory: "Inventory",
  GlobalStore: "Global_Store",
  B2BStore: "B2B_Store",
  Coupon: "Coupon",
  Reels: "Clips",
  Payments: "Payments",
  HelpCenter: "Tickets",
  Users: "Users",
  Roles: "Roles",
  RewardQR: "RewardQR",
  Wallet: "Wallet",
  Logs:"Logs"
};

export const perms = {
  view: "VIEW_LIST",
  add: "ADD",
  edit: "EDIT",
  delete: "DELETE",

  denyOrder: "order_deny",

  downloadReports: "download_reports",
};
